Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handlePinterestBuild = exports.pinterestClassNames = void 0;

var _utils = require("../../utils");

var isPinterestScriptAdded = false;
var pinterestClassNames = [".pinterest-pin", ".pinterest-board", ".pinterest-follow-button"].join(",");
exports.pinterestClassNames = pinterestClassNames;
var pinterestEmbedScript = "!function(a,b,c){var d,e,f;d=\"PIN_\"+~~((new Date).getTime()/864e5),a[d]?a[d]+=1:(a[d]=1,a.setTimeout(function(){e=b.getElementsByTagName(\"SCRIPT\")[0],f=b.createElement(\"SCRIPT\"),f.type=\"text/javascript\",f.async=!0,f.src=c.mainUrl+\"?\"+Math.random(),e.parentNode.insertBefore(f,e)},10))}(window,document,{mainUrl:\"//assets.pinterest.com/js/pinit_main.js\"});";

var pinterestBuild = function pinterestBuild() {
  if (typeof window.PinUtils !== "undefined" && window.PinUtils && typeof window.PinUtils.build === "function") {
    window.PinUtils.build();
  }
};

var handlePinterestBuild = function handlePinterestBuild() {
  if (document.querySelector(pinterestClassNames) !== null) {
    if (!isPinterestScriptAdded) {
      (0, _utils.createScriptTag)(null, pinterestEmbedScript);
      isPinterestScriptAdded = true;
      return {
        status: 'createScriptTag'
      };
    }
  }

  pinterestBuild();
  return {
    status: 'pinterestBuild'
  };
};

exports.handlePinterestBuild = handlePinterestBuild;